import React, { useState } from 'react'
import { Input, Segmented, Switch, Table } from 'antd'
import { SearchOutlined } from '@ant-design/icons'
import { RoleSettingsSection } from './RoleSettingsSection'

export interface RoleNotificationSetting {
  type: string
  label: string
  enabled: boolean
}

export const DEFAULT_ROLE_NOTIFICATIONS: RoleNotificationSetting[] = [
  { type: 'new_appeal', label: 'Новые обращения', enabled: false },
  { type: 'new_measurement', label: 'Новые замеры', enabled: false },
  { type: 'new_montage', label: 'Новые монтажи', enabled: false },
  {
    type: 'new_claim_request',
    label: 'Новые заявки на рекламацию',
    enabled: false,
  },
  {
    type: 'new_claim_work',
    label: 'Новая работа по рекламации',
    enabled: false,
  },
  { type: 'new_hr_response', label: 'Новый отклик HR', enabled: false },
  { type: 'avito_incoming_message', label: 'Сообщения Авито', enabled: false },
  { type: 'ai_agent_response', label: 'Ответы AI-агентов', enabled: false },
  {
    type: 'hr_compliance_expiring',
    label: 'Истекает срок полиса/страховки',
    enabled: false,
  },
  {
    type: 'hr_compliance_expired',
    label: 'Истёк срок полиса/страховки',
    enabled: false,
  },
  { type: 'windraw_pickup_debt', label: 'Самовывозы с задолженностью', enabled: false },
]

interface RoleNotificationsEditorProps {
  notifications: RoleNotificationSetting[]
  onChange: (notifications: RoleNotificationSetting[]) => void
}

export const RoleNotificationsEditor = ({
  notifications,
  onChange,
}: RoleNotificationsEditorProps) => {
  const [search, setSearch] = useState('')
  const [onlyEnabled, setOnlyEnabled] = useState(false)
  const filtered = notifications.filter(
    item =>
      (!onlyEnabled || item.enabled) &&
      item.label.toLocaleLowerCase('ru').includes(search.trim().toLocaleLowerCase('ru')),
  )
  const updateNotification = (type: string, enabled: boolean) => {
    onChange(notifications.map(item => (item.type === type ? { ...item, enabled } : item)))
  }

  return (
    <RoleSettingsSection
      className="role-notifications"
      title="Уведомления"
      description="Выберите события, о которых будут узнавать сотрудники с этой ролью."
    >
      <div className="role-toolbar">
        <Input
          allowClear
          prefix={<SearchOutlined />}
          aria-label="Поиск уведомлений"
          placeholder="Найти уведомление"
          value={search}
          onChange={event => setSearch(event.target.value)}
        />
        <Segmented
          aria-label="Фильтр уведомлений"
          value={onlyEnabled ? 'enabled' : 'all'}
          onChange={value => setOnlyEnabled(value === 'enabled')}
          options={[
            { label: 'Все', value: 'all' },
            { label: 'Включённые', value: 'enabled' },
          ]}
        />
      </div>
      <Table
        rowKey="type"
        size="small"
        pagination={false}
        dataSource={filtered}
        locale={{ emptyText: search ? 'Уведомления не найдены' : 'Нет включённых уведомлений' }}
        columns={[
          {
            title: 'Уведомление',
            dataIndex: 'label',
          },
          {
            title: 'Получать',
            dataIndex: 'enabled',
            width: 140,
            render: (value, record) => (
              <Switch
                aria-label={record.label}
                checked={Boolean(value)}
                onChange={checked => updateNotification(record.type, checked)}
              />
            ),
          },
        ]}
      />
    </RoleSettingsSection>
  )
}
